import { getPrimaryBalanceType } from '../../master-data/balance-types/get-primary-balance-type';
import { getMemberBalances } from './get-member-balances';
export const getPrimaryMemberBalance = () => {
    const primaryBalanceType = getPrimaryBalanceType();
    const memberBalances = getMemberBalances();
    if (!primaryBalanceType || !memberBalances)
        return;
    return memberBalances.find(balance => balance.balanceTypeId === primaryBalanceType.id);
};
